import { Component, OnInit, Input } from '@angular/core';
import { Media } from 'src/app/models/service/media';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UrlService } from 'src/app/services/util/url.service';

@Component({
    selector: 'app-document-card',
    templateUrl: './document-card.component.html',
    styleUrls: ['./document-card.component.scss'],
    standalone: false
})
export class DocumentCardComponent implements OnInit {

  @Input() media: Media;

  constructor(private urlService: UrlService, private authService: AuthService) { }

  ngOnInit(): void {

  }

  openDocument(): void {
    const realm = this.authService.principal.provider;
    this.urlService.openUrlInNewTab(this.media.mediaHref + '?realm=' + realm);
  }
}
